import React, { useCallback, useEffect, useState } from 'react';
import { TrackingInfoEvent } from '../../../../../../__generated__/loma';
import { useTranslations } from '../../../../hooks/useTranslations';
import { SmallHeader } from '../../../ui/Header/Header';
import TextLink from '../../../ui/TextLink/TextLink';
import useIsMobile from '../hooks/useIsMobile';
import History from './ThemedHistory';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './DeliveryHistory.module.css';

interface Props {
  history: TrackingInfoEvent[];
}

const DeliveryHistory = (props: Props): React.ReactElement => {
  const { history } = props;

  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);
  const onToggle = useCallback(() => setIsOpen((prev) => !prev), []);

  const {
    blockDeliveryStatusHideHistory,
    blockDeliveryStatusHistoryTitle,
    blockDeliveryStatusShowHistory,
  } = useTranslations();

  const { linksNoneDefault, linksNoneHover } = useTheme();

  useEffect(() => {
    setIsOpen(!isMobile);
  }, [isMobile]);

  return (
    <div className={styles.container}>
      <TextLink
        linkStyle={{
          sDefault: linksNoneDefault,
          sHover: linksNoneHover,
        }}
        onClick={onToggle}
      >
        {isOpen
          ? blockDeliveryStatusHideHistory
          : blockDeliveryStatusShowHistory}
      </TextLink>
      {isOpen && (
        <>
          <SmallHeader as="h3" containerCustomStyle={{ marginTop: '1rem' }}>
            {blockDeliveryStatusHistoryTitle}
          </SmallHeader>
          <ol style={{ margin: 0, listStyle: 'none', padding: 0 }}>
            {history.map((event, i) => (
              <History key={`${event.date}_${i}`} event={event} />
            ))}
          </ol>
        </>
      )}
    </div>
  );
};

export default DeliveryHistory;
